module.exports = __webpack_public_path__ + "img/auth-icon.4ecb0cc9.png";